var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 17",
    width: 12,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 17,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAMAAADe472QAAAAAXNSR0IB2cksfwAAALdQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////A93RcQAAAD10Uk5TlfrFMQDZ/+NNSdv3bAEovv6KChWgrBsGgMwyYO5KQcvwWP2vXeRGezOwHSbAjww91fZuX+zhTt/JMH3opQByRp8AAACRSURBVHicLY8xC8JQDITvwIe0S4WCRUEUHBw6CDoI/v9NUHBweHQRhIJDBwd1cPCS9wLJ3bckF4IqpGKg8JehkAvkx2FUypTkywGVmYqDA2p+3xpPB6AxN+0TYM5enQHN+IFFhhXv4NKhnsSAWdEZ+O41o23bSDRudqeVtLx6nL10y3MKerhgx1NOfSTjkP/5A8L9HbQk/JddAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.c75704674af16833790d214331cce09b.svg";
export { ForwardRef as ReactComponent };